import { AdminState } from './models';

export const namespace = 'vtn-redact-state-admin';

export const defaultState: AdminState = {
  isScanning: false,
  hasScanned: false,
  scanError: undefined,
  scannedAt: undefined,
  liveDefinitions: [],
  valuesUnavailable: false,
  // Not 'unknown' — that is an answer ("we asked and could not tell"), and
  // showing it before the query returns reports a failure that has not
  // happened. Controls are enabled in both states either way.
  rootOrgStatus: 'checking',
  organizationName: undefined,
  pendingKeys: [],
  errorsByKey: {},
  successByKey: {},
};

export interface AdminStore {
  [namespace]: AdminState;
}
